import $ from 'jquery';
import IMask from 'imask';

const imask = {
    initBirthdayFields() {
        $('input[name="birthdate"]').each((index, element) => {
            IMask(element,
                {
                    mask: Date,
                    min: new Date(1900, 0, 1),
                    max: new Date(),
                    lazy: false
                });
        });
    }
};

// DOM ready
$(() => {
    imask.initBirthdayFields();
});

export default imask;